/**
 * Which parts of MPG AI the console shows. The dashboard's morning brief and
 * Jobs at risk went live first (client 2026-10-26), then the Jobs list's risk
 * badge (2026-10-28); the rest is built and tested but hidden until the client
 * says so. Flip a flag to show it again.
 * The server keeps every route (admin only), so this hides, never removes.
 */
export const aiFeatures = {
  /** The dashboard's morning brief and Jobs at risk. */
  dashboard: true,
  /**
   * Apply cards on the brief. Off (client 2026-10-27): an SLA change moves
   * every customer's delivery date and rush price, and every admin sees the
   * brief. The server's AI_BRIEF_ACTIONS stops the brief making cards at all;
   * this also hides any made before.
   */
  briefActions: false,
  /** The /admin/ai chat: sidebar link, and the brief's "Ask a follow-up". The URL itself still opens. */
  chat: false,
  /** The order page's MPG AI check card and Ask MPG AI button. */
  orderCheck: false,
  /** The risk badge on the Jobs list. Arithmetic, not the model, so it costs nothing to show. */
  jobRisk: true,
}
